document.addEventListener('DOMContentLoaded', function() {
  class WishDrawer extends HTMLElement {
    constructor() {
      super();
      // Gestire la chiusura con il tasto Escape
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      // Gestire la chiusura con il click sull'overlay
      this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // I-TL2 16/10/2026 (DECISIONI-MAIN §128): Esc closes the drawer wherever the focus is, as in the language and country panel, and only
      // the drawer: the phone menu under it closes on the keyup of Esc, so that keyup stops here
      this.onKeydownEscape = (evt) => {
        if (evt.key !== 'Escape' || !this.classList.contains('active')) return;
        evt.preventDefault();
        this.close();
        const stopKeyup = (e) => { if (e.key === 'Escape') e.stopPropagation(); document.removeEventListener('keyup', stopKeyup, true); };
        document.addEventListener('keyup', stopKeyup, true);
      };
      // Inizializzare gli event listener sull'icona di ricerca
      this.initWishIconListeners();
    }

    initWishIconListeners() {
      // Trovare tutte le icone di ricerca e assegnare l'event listener
      const wishIcons = document.querySelectorAll('[id*="wishIconHeader"]');
      wishIcons.forEach((icon) => {
        icon.addEventListener('click', this.open.bind(this));
      });
    }

    open() {
      const wishDrawer = document.getElementById('WishDrawer');
      // I-TL2 16/10/2026 (DECISIONI-MAIN §128): the button that opened the drawer gets the focus back when it closes
      this.opener = document.activeElement;
      // Aggiungere le classi animate e active
      setTimeout(() => { wishDrawer.classList.add('animate', 'active'); });

      // I-TL2 16/10/2026 (DECISIONI-MAIN §128): the focus goes to the first element that can take it (the old target, .drawer__inner,
      // is a div that cannot, so the focus stayed on the page). Fallback timer in case no transitionend reaches the drawer.
      let focused = false;
      const focusDrawer = () => {
        if (focused || !wishDrawer.classList.contains('active')) return;
        focused = true;
        const focusElement = getFocusableElements(wishDrawer).find((el) => el.offsetParent !== null) || wishDrawer.querySelector('.drawer__close');
        trapFocus(wishDrawer, focusElement);
      };
      wishDrawer.addEventListener('transitionend', focusDrawer, { once: true });
      setTimeout(focusDrawer, 500);
      document.addEventListener('keydown', this.onKeydownEscape);
      if (typeof __this !== 'undefined' && __this && typeof __this._wishlistPageWidgetData === 'function') __this._wishlistPageWidgetData();
      // Prevenire lo scrolling del body
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');
    }

    close() {
      const wishDrawer = document.getElementById('WishDrawer');
      wishDrawer.classList.remove('active');
      document.removeEventListener('keydown', this.onKeydownEscape);
      removeTrapFocus(this.opener && document.contains(this.opener) ? this.opener : null);
      this.opener = null;
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }

  customElements.define('wishlist-drawer', WishDrawer);
});
